import { observer } from "mobx-react-lite";
import type { FC } from "react";
import type { UseFormReturn } from "react-hook-form";

import { Tags } from "@/components/atoms";
import { RatingSwitchGroup } from "@/components/molecules";
import type { Option } from "@/components/molecules/SelectOptions/BaseSelectOptions";
import { FormControl, FormField, FormItem } from "@/components/ui/form";

import type { DishFormType } from "../../BrandFormMenu/types";

const Tastes = {
  Spice: 0,
  Sweetness: 0,
  Sourness: 0,
  Bitterness: 0,
  Umami: 0,
};

interface Props {
  form: UseFormReturn<DishFormType>;
  mealTimeOptions: Option[];
  occasionsOptions: Option[];
  disabled: boolean;
}

const StepMealTaste: FC<Props> = observer(
  ({ form, mealTimeOptions, occasionsOptions, disabled }) => {
    const { control, watch } = form;
    const ratings = watch("ratings") ?? Tastes;

    return (
      <div className="flex flex-col gap-8">
        <div>
          <h2 className="text-xl font-bold mb-5">Meal context</h2>
          <div className="flex flex-col gap-5">
            <Tags
              tagsList={mealTimeOptions}
              title="Meal time"
              form={control}
              name="meal"
              disabled={disabled}
            />
            <Tags
              tagsList={occasionsOptions}
              title="Occasion"
              form={control}
              name="occasion"
              disabled={disabled}
            />
          </div>
        </div>

        <div>
          <h2 className="text-xl font-bold mb-4">Taste profile</h2>
          <div className="grid grid-cols-2 gap-x-10 gap-y-5">
            {Object.entries(ratings).map(([taste, rating]) => (
              <FormField
                key={taste}
                control={control}
                name="ratings"
                render={() => (
                  <FormItem>
                    <FormControl>
                      <RatingSwitchGroup
                        taste={taste}
                        rating={rating as number}
                        form={form}
                        disabled={disabled}
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
);

export default StepMealTaste;
